import * as React from 'react';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { useQuery } from 'react-query';
const zip = new JSZip();
const fileFetcher = async url => {
  const request = await fetch(url);
  return await request.blob();
};
const fileNamefromUrl = url => {
  //images.weserv.nl/?url=https://spafaxscoutimageserver.azurewebsites.net/azure/4888f52b-a726-4040-a404-2a51d0074a50/Rhythm%20of%20the%20Street%20-%20Al%20ritmo%20de%20la%20calle%20(11).jpg?width=
  const name = url.split('/')[url.split('/').length - 1].split('?')[0];
  return name;
};
const sanitizeFileName = fileName => {
  if (!fileName) return;
  return fileName.replace(/[<>:"/\\|?*(),.]/g, '_');
};
export function useZipper(_ref) {
  let {
    urls,
    fileName
  } = _ref;
  const makeZip = async folder => {
    const content = await folder.generateAsync({
      type: 'blob'
    });
    saveAs(content, sanitizeFileName(fileName));
  };
  const {
    data,
    error,
    isSuccess
  } = useQuery(fileName, () => Promise.all(urls.map(url => fileFetcher(url))), {
    enabled: urls.length > 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false
  });
  React.useEffect(() => {
    if (data && fileName) {
      const imageFiles = data.map((blob, i) => new File([blob], fileNamefromUrl(urls[i])));
      const folder = zip.folder(fileName);
      if (folder) {
        imageFiles.forEach(image => {
          folder === null || folder === void 0 || folder.file(decodeURIComponent(image.name), image);
        });
        makeZip(folder);
      }
    }
  }, [data, fileName]);
  return {
    zipped: urls.map(url => fileNamefromUrl(url)),
    error,
    isSuccess
  };
}